import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ThemeControls from "../Component/AllThemesControl.js";
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import { FormContext } from '../Component/Forms/FormContext.js';
import Element from "./Element.js"
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import IconButton from '@mui/material/IconButton';
import { VscSend } from "react-icons/vsc";
import { ReactComponent as Bin } from '../images/Table/Bin.svg';
import Dialog from '@mui/material/Dialog';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { MasterContext } from '../services/MasterContext.js';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import VendorCode from './Table.js'
import demo from './demo.json';
import DeleteRow from '../Component/DataTable/Delete';
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext.js';
//APISERVICES
import { APIGET, APIPATCH } from '../services/APIServices.js';
//import SuccessPage from '../SuccessPage';

//Navigation
import { useNavigate, Link } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

function RenderRow({ index, row, columns, editJson, setFilteredData, setDelPosition, setOpenDel }) {
    const [arr, setArr] = useState(row);
    const { contextJson } = React.useContext(FormJSONCreateContext);

    const handleChange = useCallback((id, event, value) => {
        setArr(prevArr => ({
            ...prevArr,
            [id]: value
        }));
        setFilteredData(prevArr => {
            const updatedArr = [...prevArr];
            updatedArr[index] = {
                ...updatedArr[index],
                [id]: value
            };
            return updatedArr; // Return the updated array
        });
    }, []);
    function handleSuccessMsgUpdate(data) {
        if (data.dataRecevied.statusCode === "SUCCESS" || data.dataRecevied.statusCode === "Success") {
          alert('Successfully Updated')
        //   setErrorType('success')
        //   setErrorOpen(true)
        }
      }
    
    async function updateData(data, path) {
        console.log(data)
        try {
          const response = await APIPATCH('mm/marketmgt/gtsGatewayvos/'+ data['gatewayvosid'], data, contextJson, handleSuccessMsgUpdate, {});
          if (response) {
            response.then((responseData) => {
            })
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      }

    return (
        <TableRow>
            {columns.map((column, i) => (
                (column.field_type && column.field_type !== 'hidden') &&
                <StyledTableCell key={column.field_id}>
                    {
                        <FormContext.Provider value={{ handleChange }}>
                            <Element 
                                key={i} 
                                field={{ 
                                    ...column, 
                                    field_label: "", 
                                    field_value: (column.field_id && arr.hasOwnProperty(column.field_id)) ? arr[column.field_id] : ((column.temp_id && arr.hasOwnProperty(column.temp_id)) ? arr[column.temp_id] : '')
                                }} 
                            />
                        </FormContext.Provider>
                    }
                </StyledTableCell>
            ))}
            <StyledTableCell>
                <IconButton aria-label="expand row" size="mediam" onClick={()=>{updateData(arr,index)}}>
                <VscSend/>
                </IconButton>
                <IconButton aria-label="expand row" size="small" >
                <Bin onClick={() => {setDelPosition(index);setOpenDel(true)}}/>
              </IconButton>
            </StyledTableCell>
        </TableRow>
    );
}


export default function RoutingInfo(props) {
    const { useStyles, useStyle } = ThemeControls;
    const classes = useStyles();
    const classe = useStyle();
    const ref = useRef();
    const { id, field_context, field_id, field_option_src } = props;

    const _columns = useMemo(() => {
        const columns = [];
        if (field_context) {
            Object.values(field_context).forEach((context) => {
                columns.push(...context.fields);
            });
        }
        return columns;
    }, [field_context]);

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [open, setOpen] = React.useState(false);
    const [refresh, setRefresh] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [editJson, setEditJson] = useState(field_context[Object.keys(field_context)[0]]);
    const { handleChange: handleChangeParent } = useContext(FormContext);
    const [btnLoading, setBtnLoading] = React.useState(false);
    const [delPosition, setDelPosition] = useState();
    const [openDel, setOpenDel] = React.useState(false);
    const apiPath = `mm/marketmgt/gtsGatewayvos/filter?accountvosid=${id}`;
    // let tempData=dataSource
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { contextJson } = React.useContext(FormJSONCreateContext);
    const navigate = useNavigate();

    const deleteFlow = {
        "deleteLabelId":"gatewayname",
          "contextHeading": "",
          "auth":false,
          "apiContext": "mm/marketmgt/gtsGatewayvos",
          "deleteType": "single"
        }
    const apiContextObj={...deleteFlow}

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await APIGET(apiPath);
                if (response.data) {
                    setDataSource(Array.isArray(response.data) ? response.data : [response.data]);
                    setFilteredData(response.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        if (apiPath&&id) {
            fetchData();
        }
    }, [apiPath, refresh]);

    useEffect(() => {
       if(filteredData&&filteredData.length>0){
        const data = {};
       
        // handleChangeParent(field_id, {}, data);
       }
    }, [filteredData]);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSource.length) : 0;

    const visibleRows = React.useMemo(
        () =>
           dataSource.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, dataSource],
    );

    // useEffect(() => {
    //     const startIndex = page * rowsPerPage;
    //     const endIndex = startIndex + rowsPerPage;
    //     setDataSource(filteredData.slice(startIndex, endIndex));
    // }, [filteredData, page, rowsPerPage]);

    function validateThisForm(jsonContext) {
        let return_error = true;
        jsonContext.fields.forEach(field => {
          if (!elementValidation(field)) {
            return_error = false;
             
            return false;
          }
        });
        return return_error;
      }

      async function fetchData(path) {
        try {
            const response = await APIGET(path);
            if (response.data && response.data.length > 0) {
                setErrorMsg('Routing Already exist for selected breakout')
                setBtnLoading(false)
                return false;
            } else {
                setBtnLoading(false)
                return true;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return true;
        }
    }


    return (
        <>
            <Dialog className={classes.poup}
                open={openDel}
                maxWidth="sm"
                aria-labelledby="responsive-dialog-title"
            >
                <DeleteRow index={delPosition} selectedBulk={[]} formFieldsJson={contextJson} deleteType={'single'} dataArr={visibleRows} close={() => (setOpenDel(false))} apiContextObj={apiContextObj} contextHeading={apiContextObj.contextHeading} />
            </Dialog>
            {dataSource.length>0&&<div className={classe.breakForm}>
                <TableContainer className={classes.table}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {_columns.map((column) => (
                                    column.field_type !== 'hidden'&&<StyledTableCell key={column.field_id}>
                                    <TableSortLabel>
                                        {column.field_label}
                                    </TableSortLabel>
                                </StyledTableCell>
                                ))}
                                <StyledTableCell>Action</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {visibleRows.map((row, index) => (
                            // {dataSource.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <RenderRow key={index} index={index} row={row} columns={_columns} editJson={editJson} setEditJson={setEditJson} tempData={filteredData} setFilteredData={setFilteredData} setDelPosition={setDelPosition} setOpenDel={setOpenDel}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.pagination}>
                    <TablePagination
                        component="div"
                        labelRowsPerPage='Show row per page'
                        count={dataSource.length}
                        page={page}
                        onPageChange={handlePageChange}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 50, 100, 500]}
                    />
                </div>
            </div>}
        </>
    );
}
